import React from 'react';
const IconFormAddSquare = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21 3H3V21H21V3ZM17 13H13V17H11V13H7V11H11V7H13V11H17V13Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconFormAddSquare;